
import { defineComponent, watch, computed, onMounted, PropType, onUnmounted } from 'vue'
import { store } from '@/store'
import { Route, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: false
    }
  },
  name: 'RouteMap',
  setup (props) {
    const loading = store.map.get(state => state.loading)

    onMounted(() => {      
      store.map.createMap('map', props.route)
    })
    
    const theme = computed(() => store.global.state.theme)

    watch(theme, async (theme) => {
      await store.map.setTheme(theme)
      store.map.updateGeometry(props.route.geometry, props.liveState)
    })

    watch(() => props.route.geometry, () => {      
      console.log('UPDATING GEOMETRY')
      store.map.updateGeometry(props.route.geometry, props.liveState)
    }, { deep: true })

    watch(() => props.liveState?.driving, () => {            
      store.map.updateGeometry(props.route.geometry, props.liveState)
    })

    function zoom(change: number) {
      store.map.zoom(change)
    }

    onUnmounted(() => {
      store.map.terminate()
    })
    
    return { loading, zoom }
  }
})
